import React from "react";
import { Box, SxProps } from "@mui/system";
import { ReactNode, useMemo } from "react";
import { Link as MuiLink } from "@mui/material";
import { termsOfServiceHref } from "../constants";

// TODO: This should be shared, and replace the other use of the old footer in billing management.
//       That page is not exposed currently, so I'm defering that refactor.

export function Footer({
  sx,
  // Avoids navigating away from account creation by default.
  // Another default may be more suited to other pages.
  target = "_blank",
}: {
  sx?: SxProps;
  target?: "_blank" | undefined;
}) {
  return useMemo(
    () => (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit, clamp(20ch, 0.20 * 100vw, min(40ch, 0.5*100vw)))",
          justifyContent: "center",
          placeItems: "start center",

          gap: "4ch",
          bgcolor: "var(--de-color-corp-dark-blue)",
          color: "white",
          padding: "4ch",
          ...sx,
        }}
      >
        {footerData.map((section) => (
          <Box key={section.name} sx={{ display: "grid", gap: "1rem" }}>
            <Box sx={{ fontWeight: "600" }}>{section.name}</Box>
            {section.links.map((link: { href: string; label: ReactNode }) => (
              <MuiLink key={link.href} href={link.href} target={target}>
                {link.label}
              </MuiLink>
            ))}
          </Box>
        ))}
      </Box>
    ),
    [sx, target]
  );
}
const footerData = [
  {
    name: "Resources",
    links: [
      { label: "Product Overview", href: "https://decodable.co/product" },
      {
        label: "Solutions",
        href: "https://www.decodable.co/solutions",
      },
      { label: "Documentation", href: "https://docs.decodable.co" },
      { label: "Pricing", href: "https://decodable.co/pricing" },
    ],
  },
  {
    name: "Policies",
    links: [
      { label: "Terms of Service", href: termsOfServiceHref },
      {
        label: "Privacy Policy",
        href: "https://www.decodable.co/legal/privacy-policy",
      },
      { label: "Security", href: "https://www.decodable.co/security" },
    ],
  },
  {
    name: "Company",
    links: [
      { label: "About Decodable", href: "https://www.decodable.co/about" },
      {
        label: "Careers",
        href: "https://www.decodable.co/careers",
      },
    ],
  },
  {
    name: "Contact",
    links: [
      { label: "Email support", href: "https://www.decodable.co/contact" },
      {
        label: "Community Slack",
        href: "https://decodablecommunity.slack.com/join/shared_invite/zt-uvow71bk-Uf914umgpoyIbOQSxriJkA#/shared-invite/email",
      },
    ],
  },
] as const;
